import { Box } from '@chakra-ui/react'

export default Box
